import { useEffect, useState } from "react";
import { Flame, CheckCircle2, PartyPopper, Loader2 } from "lucide-react";

export default function CheckoutSuccessPage() {
  const [syncing, setSyncing] = useState(true);

  useEffect(() => {
    // Sync subscription status from Stripe
    const syncSubscription = async () => {
      try {
        const response = await fetch('/api/membership/sync', {
          method: 'POST',
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          console.log('Subscription synced:', data);
        }
      } catch (error) {
        console.error('Error syncing subscription:', error);
      } finally {
        setSyncing(false);
      }
    };

    syncSubscription();

    const timer = setTimeout(() => {
      window.location.href = '/';
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="p-3 bg-primary/20 rounded-xl">
            <Flame className="w-8 h-8 text-primary animate-pulse" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground">
            myFit<span className="text-primary">Beats</span>
          </h1>
        </div>

        <div className="bg-card border border-border/50 rounded-xl p-8">
          <div className="flex justify-center gap-2 mb-4">
            <CheckCircle2 className="w-12 h-12 text-green-500" />
            <PartyPopper className="w-12 h-12 text-primary" />
          </div>
          <h2 className="text-2xl font-bold mb-2" data-testid="text-success-title">Welcome to myFitBeats!</h2>
          <p className="text-muted-foreground mb-4" data-testid="text-success-message">
            Your subscription is active and ready to go!
          </p>
          <p className="text-sm text-muted-foreground">
            Redirecting you to your dashboard...
          </p>
        </div>
      </div>
    </div>
  );
}
